import { useEffect } from 'react';

export const useScrollToTop = (dependency) => {
  useEffect(() => {
    const scrollContainer = document.getElementById('main-scroll-container');
    if (scrollContainer) {
      try {
        scrollContainer.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      } catch {
        scrollContainer.scrollTop = 0;
      }
      scrollContainer.scrollTop = 0;
    }
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [dependency]);
};
